export class Metadata {
	public title: string | null
	public artist: string | null
	public album: string | null
	public genre: string | null
	public year: number | null
	public length: number
	public popularity?: number | null
	public explicit?: boolean | null
	public bpm?: number | null
	public key?: number | null
	public mode?: number | null
	public accousticness?: number | null
	public danceability?: number | null
	public energy?: number | null
	public instrumentalness?: number | null
	public liveness?: number | null
	public loudness?: number | null
	public speechiness?: number | null
	public valence?: number | null
	public tempo?: number | null
	public isrc?: string | null
	public lufs?: number | null

	constructor(data: {
		title: string | null
		artist: string | null
		album: string | null
		genre: string | null
		year: number | null
		length: number
		popularity?: number | null
		explicit?: boolean | null
		bpm?: number | null
		key?: number | null
		mode?: number | null
		accousticness?: number | null
		danceability?: number | null
		energy?: number | null
		instrumentalness?: number | null
		liveness?: number | null
		loudness?: number | null
		speechiness?: number | null
		valence?: number | null
		tempo?: number | null
		isrc?: string | null
		lufs?: number | null
	}) {
		this.title = data.title
		this.artist = data.artist
		this.album = data.album
		this.genre = data.genre
		this.year = data.year
		this.length = data.length
		this.popularity = data.popularity
		this.explicit = data.explicit
		this.bpm = data.bpm
		this.key = data.key
		this.mode = data.mode
		this.accousticness = data.accousticness
		this.danceability = data.danceability
		this.energy = data.energy
		this.instrumentalness = data.instrumentalness
		this.liveness = data.liveness
		this.loudness = data.loudness
		this.speechiness = data.speechiness
		this.valence = data.valence
		this.tempo = data.tempo
		this.isrc = data.isrc
		this.lufs = data.lufs
	}

	static create(data: Partial<Metadata>) {
		const defaultData = {
			title: null,
			artist: null,
			album: null,
			genre: null,
			year: null,
			length: 0,
			popularity: null,
			explicit: null,
			bpm: null,
			key: null,
			mode: null,
			accousticness: null,
			danceability: null,
			energy: null,
			instrumentalness: null,
			liveness: null,
			loudness: null,
			speechiness: null,
			valence: null,
			tempo: null,
			isrc: null,
			lufs: null,
		}

		return new Metadata({
			...defaultData,
			...data,
		})
	}
}
